import React from 'react';

/**
 * Topic pill bar + scrollable HTML content for the active help section.
 */
export default function HelpContent({ section, activeTopic, onTopicChange }) {
  const current = section.topics.find((t) => t.id === activeTopic) || section.topics[0];

  return (
    <div className="help-content">
      <div className="help-topics">
        {section.topics.map((topic) => (
          <button
            key={topic.id}
            type="button"
            className={`help-pill ${current?.id === topic.id ? 'is-active' : ''}`}
            onClick={() => onTopicChange(topic.id)}
            aria-pressed={current?.id === topic.id}
          >
            {topic.title}
          </button>
        ))}
      </div>
      <div className="help-body">
        {current ? (
          <>
            <h3 className="h5 fw-bold mb-3">{current.title}</h3>
            {/* Content is authored in this repo (static), not user input. */}
            <div className="help-html" dangerouslySetInnerHTML={{ __html: current.body }} />
          </>
        ) : (
          <p className="text-muted">Select a topic to read.</p>
        )}
      </div>
    </div>
  );
}
